<div class="container">
  <div class="container__header">
    <div class="container__header__label">
      <h4>
        {{ role?.label }}
        <mat-icon
          *ngIf="readOnly; else editRole"
          matTooltip="This role cannot be edited."
          matTooltipShowDelay="500"
          matTooltipPosition="right"
          >lock</mat-icon
        >
        <ng-template #editRole>
          <mat-icon
            matTooltip="Edit role"
            matTooltipShowDelay="500"
            matTooltipPosition="above"
            (click)="editRoleClicked.emit()"
            class="cursor-pointer"
            >edit</mat-icon
          >
          <mat-icon
            matTooltip="Remove role"
            matTooltipShowDelay="500"
            matTooltipPosition="above"
            (click)="removeRoleClicked.emit()"
            class="cursor-pointer"
            >delete</mat-icon
          >
        </ng-template>
        <p>
          <ng-container *ngIf="role?.userCount as userCount; else noUserMsg">
            There {{ role.userCount > 1 ? 'are' : 'is' }} <strong>{{ userCount }}</strong>
            {{ role.userCount > 1 ? 'users' : 'user' }} assigned to this role.
          </ng-container>
          <ng-template #noUserMsg> There are <strong>no</strong> users assigned to this role. </ng-template>
        </p>
      </h4>
    </div>
    <ts-button (click)="onPermissionsSaved()" *ngIf="!readOnly">Save </ts-button>
  </div>
  <div class="container__modules">
    <div *ngFor="let module of modules" class="container__modules__item">
      <div class="container__modules__item__header">
        <div class="container__modules__item__header__left" (click)="module.expanded = !module.expanded">
          <button mat-icon-button>
            <mat-icon>{{ module.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
          </button>
          {{ module.label }}
        </div>
        <div class="container__modules__item__header__center"></div>
        <div
          class="container__modules__item__header__right"
          [matTooltip]="readOnly ? 'Permissions in this role cannot be changed.' : ''"
          matTooltipShowDelay="500"
          matTooltipPosition="left"
        >
          <ng-container *ngIf="!hasNewPermissionsOn && getModuleCheckboxState(module) as checkboxState">
            <mat-checkbox
              color="primary"
              [checked]="checkboxState === 'indeterminate' ? false : checkboxState === 'checked'"
              [indeterminate]="checkboxState === 'indeterminate'"
              (change)="setModulePermissionsState($event.checked, module)"
              [disabled]="readOnly"
            ></mat-checkbox>
          </ng-container>
        </div>
      </div>
      <div [@slideInOut]="module.expanded ? 'in' : 'out'" class="container__modules__item__permissions">
        <div
          *ngFor="let permissionRole of module.permissionsRoles; let i = index"
          class="container__modules__item__permissions__item"
        >
          <div class="container__modules__item__permissions__item__left">
            {{ permissionRole.permission.label }}
            <p *ngIf="permissionRole.permission.description?.length">{{ permissionRole.permission.description }}</p>
          </div>
          <div class="container__modules__item__permissions__item__center"></div>
          <div
            class="container__modules__item__permissions__item__right"
            [matTooltip]="readOnly ? 'Permissions in this role cannot be changed.' : ''"
            matTooltipShowDelay="500"
            matTooltipPosition="left"
          >
            <app-settings-permissions-value
              [permissionRole]="permissionRole"
              [readOnly]="readOnly"
              (change)="onPermissionChange($event)"
            ></app-settings-permissions-value>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
